/* eslint-disable no-var */
// A country store's home page, /us: what that store sells, in its currency.
//
// Shared by the build-time prerender (scripts/prerender-meta.js, which knows
// the store's whole catalogue) and the React marketplace when it is opened at
// /us (which knows what it has loaded), so the title, description and
// canonical are the same in the first response and after the app takes over.
// India's home is / and is not built here.
//
// CommonJS on purpose, like brandPage.js: Node requires it at build time.

var brandPage = require('./brandPage');

var SITE_URL = brandPage.SITE_URL;

var listNames = function (names, total) {
  if (!names.length) return '';
  var more = total > names.length;
  if (names.length === 1) return names[0] + (more ? ' and more' : '');
  return more ? names.join(', ') + ' and more' : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
};

/**
 * Title, heading, description and address for a store's home.
 *
 * `count` is how many brands the store sells (omitted when not known),
 * `maxPct` its best discount, `names` a few brands to name (leading ones
 * first), `currency` the store's ("USD", or "EUR" once the store is switched to
 * its own). Returns null for India or a code that is not a
 * store address.
 */
var storeHomeMeta = function (country, options) {
  var opts = options || {};
  var prefix = brandPage.countryPath(country);
  if (!prefix) return null;
  var siteUrl = (opts.siteUrl || SITE_URL).replace(/\/$/, '');
  var place = brandPage.placeName(country);
  var currency = String(opts.currency || 'USD').toUpperCase();
  var maxPct = Math.round(Number(opts.maxPct) || 0);
  var count = Number(opts.count) > 0 ? Math.round(Number(opts.count)) : 0;
  var names = (opts.names || []).filter(Boolean).slice(0, 4);

  var heading = 'Subscriptions and gift cards in ' + place;
  var title = heading + (maxPct > 0 ? ', up to ' + maxPct + '% off' : '') + ' | Fleek';
  var description =
    (count ? 'Buy from ' + count + ' brands on Fleek in ' + place : 'Buy subscriptions and gift cards on Fleek in ' + place) +
    (names.length ? ', including ' + listNames(names, count || names.length + 1) : '') +
    '. Prices in ' + currency + ', paid by card, delivered by email within 24 hours.';

  return {
    country: String(country).toUpperCase(),
    prefix: prefix,
    url: siteUrl + prefix,
    place: place,
    heading: heading,
    title: title,
    description: description,
  };
};

/**
 * A store's home from its brand pages (buildBrandPage results with
 * options.country): the meta above, with the count, best discount and the
 * brands to name worked out from what the store sells.
 */
var buildStoreHome = function (country, pages, options) {
  var opts = options || {};
  var buyable = (pages || []).filter(function (p) {
    return p && p.buyableCount > 0;
  });
  if (!buyable.length) return null;
  var leading = buyable.slice().sort(function (a, b) {
    return (b.maxPct || 0) - (a.maxPct || 0) || a.name.localeCompare(b.name);
  });
  var maxPct = leading[0].maxPct || 0;
  return storeHomeMeta(country, {
    siteUrl: opts.siteUrl,
    currency: buyable[0].currency,
    maxPct: maxPct,
    count: buyable.length,
    names: leading.slice(0, 4).map(function (p) {
      return p.name;
    }),
  });
};

module.exports = { storeHomeMeta: storeHomeMeta, buildStoreHome: buildStoreHome };
